import request from '@/utils/request'
// 查档确认时间
export function getConsultTime(params) {
  return request({
    url: 'client-message-operate!consultFilesTime.do?param='+params,
    method: 'get',
    params
  })
}
// 查档预约提交信息
export function submitConsultFiles(data) {
  return request({
    url: 'client-message-operate!consultFilesMessage.do?param='+data,
    method: 'get',
    data
  })
}

// 查档预约查询
export function selectConsult(params) {
  return request({
    url: 'client-message-operate!consultFilesSelect.do?param='+params,
    method: 'get',
    params
  })
}
// 查档预约取消
export function delConsult(params) {
    return request({
      url: 'client-message-operate!consultFilesDel.do?param='+JSON.stringify(params),
      method: 'get',
      params
    })
  }